export const STATUS_SUBSCRIBED = 'subscribed';
export const STATUS_SENDING = 'sending';
export const STATUS_ERROR = 'error';
